const LEVELS_MAP: Record<Level, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
}

export type Level = 'debug' | 'info' | 'warn' | 'error'

class Logger {
  enabled: boolean
  level: Level

  constructor(enabled: boolean, level: Level) {
    this.enabled = enabled
    this.level = level || 'info'
  }

  debug(...logArgs: any) {
    this.log('debug', ...logArgs)
  }

  info(...logArgs: any) {
    this.log('info', ...logArgs)
  }

  warn(...logArgs: any) {
    this.log('warn', ...logArgs)
  }

  error(...logArgs: any) {
    this.log('error', ...logArgs)
  }

  log(lvl: Level, ...logArgs: any) {
    if (!this.enabled) return

    const lvlValue = LEVELS_MAP[lvl]

    if (this.allowedLevel() > lvlValue) return

    window.console[lvl](`[WF Logger] [${lvl}]`, ...logArgs)
  }

  allowedLevel() {
    return LEVELS_MAP[this.level]
  }
}

export default Logger
